import * as bootstrap from "bootstrap"

window.bootstrap = bootstrap;
window.modal = new bootstrap.Modal(document.getElementById('modal'), {backdrop: 'static', keyboard: false})